import axios from 'axios'
import { apiBaseUrl } from './config'
import { isStoredSessionStarted, getStoredSession, rawLogout, refreshToken } from '@/lib/session'
import { redirect } from '@/lib/location'

const instance = axios.create({
  baseURL: apiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'json'
  }
})

function succesInterceptor (config) {
  let authHeaders = {}
  if (isStoredSessionStarted()) {
    const { token, sessionId } = getStoredSession()
    authHeaders = {
      'Authorization': `Bearer ${token}`,
      'api-session-id': sessionId
    }
  }
  return {
    ...config,
    headers: {
      ...config.headers,
      ...authHeaders
    }
  }
}

function successResponse (response) {
  if (response.data && response.data.refreshToken) {
    refreshToken(response.data.refreshToken)
  }
  return response
}

function errorInterceptor (error) {
  // Erro de conexao seja pelo servidor estar
  // off ou o front nao estar conectado a internet
  if (error.message.match(/Network Error/)) {
    return Promise.reject(new Error('Não foi possível conectar com o servidor!'))
  }

  if (error.response.status === 400) {
    return Promise.reject(error.response.data)
  }

  if (error.response.status === 401) {
    isStoredSessionStarted() && rawLogout()
  }

  // Erros 403 utilizando timeout
  // para ser executado apos o retorno
  // da promise, permitindo o component
  // vue exibir um modal com a mensagem
  // de erro de sessao por exemplo.
  if (error.response.status === 403) {
    setTimeout(() => redirect('main'), 3560)
  }

  if (error.response.status === 500) {
    return Promise.reject(new Error(error.response.data))
  }

  if (error.response && error.response.data) {
    return Promise.reject(new Error(error.response.data.message))
  }

  // retorno sem mensagem de erro
  return Promise.reject(new Error('Ocorreu um erro inesperado!'))
}

instance.interceptors.request.use(succesInterceptor, undefined)
instance.interceptors.response.use(successResponse, errorInterceptor)

/**
 * @param {Object} options
 * @param {String} options.method
 * @param {String} options.url
 * @param {Object} options.data Dados enviados em requisicoes 'PUT', 'POST', e 'PATCH'
 * @returns {Promise}
 */
export async function request (options) {
  const { data: response } = await instance.request({
    url: options.url,
    method: options.method.toLowerCase(),
    data: options.data,
    params: options.params
  })
  return response.data
}

export default instance
